// Katlanir.js — KATLANIR BLOK (5 Eyl 2026'da kendi dosyasına çıktı)
//
// 🔑 Serkan (4 Eyl 2026): *"Rule set tabloları çok uzun — her bir başlığı
//    collapsable yap, basınca açılsın ilgili tablo, +/− mantığı yani."*
//
// 🔴 NEDEN TAŞINDI (5 Eyl): SHT-FCL kural seti FTL RULESET'ten ATPL & MED
//    modülüne taşındı (*"bir modül = bir mevzuat ailesi"*). Bileşen FTLPanel'e
//    gömülü olduğu için ikinci modülden kullanılamıyordu — InfoDot'ta yaşanan
//    aynı durum. İkinci bir kopya yazmak iki katlanır bloğun zamanla
//    ayrışması demekti.
//
// Stiller CSS değişkenlerinden okunur, panelin sözlüklerine bağlı DEĞİL.
import React from 'react';
import { AcilirBaslik } from './GosterGizle';   // başlık tasarım Y (5 Eki 2026) — tek bileşen

const V = { accent:'var(--accent)', border:'var(--border)', border2:'var(--border2)',
            t1:'var(--t1)', t3:'var(--t3)' };

// 1 Eki 2026 (TRAINING, Serkan: "training modülünün içini de rule set gibi collapse yap, çok uzun görünüyor"):
//    `birim` (sayının adı, varsayılan rule/rules), `ek` (başlıkta sayının soluna — örn. durum özeti), `testId`.
//    Varsayılanlar eskisiyle AYNI — RULE SET ve ATPL & MED değişmez.
export default function Katlanir({ baslik, kunye, sayi, acikMi, onToggle, children,
                                   birim = ['rule', 'rules'], ek = null, testId }) {
  return (
    <div style={{ marginBottom:10 }}>
      {/* 5 Eki 2026 (Serkan, tasarım Y): başlığın tamamı çerçeveli kutu, sağda ▸ SHOW / ▾ HIDE — eskiden solda +/−. */}
      <AcilirBaslik acik={acikMi} onClick={onToggle} testid={testId || `ruleset-blok-${baslik}`}>
        <span style={{ fontSize:12, fontWeight:600, color:V.t1 }}>{baslik}</span>
        {kunye && (
          <span style={{ display:'inline-block', padding:'1px 7px', borderRadius:3, fontSize:9,
                         fontWeight:700, letterSpacing:1, fontFamily:'var(--mono)',
                         color:V.t3, border:`1px solid ${V.border2}` }}>{kunye}</span>
        )}
        <span style={{ marginLeft:'auto', display:'flex', gap:8, alignItems:'center' }}>
          {ek}
          <span style={{ fontSize:10, color:V.t3, fontFamily:'var(--mono)' }}>{sayi} {sayi === 1 ? birim[0] : birim[1]}</span>
        </span>
      </AcilirBaslik>
      {acikMi && <div style={{ padding:'8px 10px 10px' }}>{children}</div>}
    </div>
  );
}
